/**
 * @desc 全局过滤器
 */

// 除了数字0，当数据布尔值为空时，展示一个默认数据。
export const showDefaultOfNull = (data) => {
  if (data === 0) return;
  return data ? data : "无";
};
